export default __webpack_public_path__ + "5dd1349c1551c158729f888ea36c9671.png";